import { Fragment, ReactNode } from 'react';

import { Typography } from '@material-ui/core';

const BULLET = ' \u2022 ';

type MetadataTextProps = {
  items: ReactNode[];
  className?: string;
};

export const MetadataText = ({ items, className }: MetadataTextProps) => {
  const filtered = items.filter(
    item =>
      item !== null && item !== undefined && item !== '' && item !== false,
  );

  if (filtered.length === 0) return null;

  return (
    <Typography
      variant="caption"
      color="textSecondary"
      component="div"
      className={className}
    >
      {filtered.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && BULLET}
          {item}
        </Fragment>
      ))}
    </Typography>
  );
};
